"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.predefinedMixins = void 0;
const typographyMixin_1 = require("./typographyMixin");
exports.predefinedMixins = {
    xxl: {
        regular: (0, typographyMixin_1.typographyMixin)('xxl', 'regular'),
        contrastInvert: (0, typographyMixin_1.typographyMixin)('xxl', 'contrastInvert'),
        overlay: (0, typographyMixin_1.typographyMixin)('xxl', 'overlay'),
        overlayInvert: (0, typographyMixin_1.typographyMixin)('xxl', 'overlayInvert'),
    },
    xl: {
        regular: (0, typographyMixin_1.typographyMixin)('xl', 'regular'),
        contrastInvert: (0, typographyMixin_1.typographyMixin)('xl', 'contrastInvert'),
        overlay: (0, typographyMixin_1.typographyMixin)('xl', 'overlay'),
        overlayInvert: (0, typographyMixin_1.typographyMixin)('xl', 'overlayInvert'),
    },
    lg: {
        regular: (0, typographyMixin_1.typographyMixin)('lg', 'regular'),
        contrastInvert: (0, typographyMixin_1.typographyMixin)('lg', 'contrastInvert'),
        overlay: (0, typographyMixin_1.typographyMixin)('lg', 'overlay'),
        overlayInvert: (0, typographyMixin_1.typographyMixin)('lg', 'overlayInvert'),
    },
    md: {
        highContrast: (0, typographyMixin_1.typographyMixin)('md', 'highContrast'),
        regular: (0, typographyMixin_1.typographyMixin)('md', 'regular'),
        lowContrast: (0, typographyMixin_1.typographyMixin)('md', 'lowContrast'),
        url: (0, typographyMixin_1.typographyMixin)('md', 'url'),
        success: (0, typographyMixin_1.typographyMixin)('md', 'success'),
        warning: (0, typographyMixin_1.typographyMixin)('md', 'warning'),
        error: (0, typographyMixin_1.typographyMixin)('md', 'error'),
        contrastInvert: (0, typographyMixin_1.typographyMixin)('md', 'contrastInvert'),
        overlay: (0, typographyMixin_1.typographyMixin)('md', 'overlay'),
        overlayInvert: (0, typographyMixin_1.typographyMixin)('md', 'overlayInvert'),
    },
    sm: {
        highContrast: (0, typographyMixin_1.typographyMixin)('sm', 'highContrast'),
        regular: (0, typographyMixin_1.typographyMixin)('sm', 'regular'),
        lowContrast: (0, typographyMixin_1.typographyMixin)('sm', 'lowContrast'),
        url: (0, typographyMixin_1.typographyMixin)('sm', 'url'),
        success: (0, typographyMixin_1.typographyMixin)('sm', 'success'),
        warning: (0, typographyMixin_1.typographyMixin)('sm', 'warning'),
        error: (0, typographyMixin_1.typographyMixin)('sm', 'error'),
        contrastInvert: (0, typographyMixin_1.typographyMixin)('sm', 'contrastInvert'),
        overlay: (0, typographyMixin_1.typographyMixin)('sm', 'overlay'),
        overlayInvert: (0, typographyMixin_1.typographyMixin)('sm', 'overlayInvert'),
    },
    xs: {
        highContrast: (0, typographyMixin_1.typographyMixin)('xs', 'highContrast'),
        regular: (0, typographyMixin_1.typographyMixin)('xs', 'regular'),
        lowContrast: (0, typographyMixin_1.typographyMixin)('xs', 'lowContrast'),
        disabled: (0, typographyMixin_1.typographyMixin)('xs', 'disabled'),
        url: (0, typographyMixin_1.typographyMixin)('xs', 'url'),
        success: (0, typographyMixin_1.typographyMixin)('xs', 'success'),
        warning: (0, typographyMixin_1.typographyMixin)('xs', 'warning'),
        error: (0, typographyMixin_1.typographyMixin)('xs', 'error'),
        contrastInvert: (0, typographyMixin_1.typographyMixin)('xs', 'contrastInvert'),
        overlay: (0, typographyMixin_1.typographyMixin)('xs', 'overlay'),
        overlayInvert: (0, typographyMixin_1.typographyMixin)('xs', 'overlayInvert'),
    },
    xxs: {
        highContrast: (0, typographyMixin_1.typographyMixin)('xxs', 'highContrast'),
        regular: (0, typographyMixin_1.typographyMixin)('xxs', 'regular'),
        lowContrast: (0, typographyMixin_1.typographyMixin)('xxs', 'lowContrast'),
        disabled: (0, typographyMixin_1.typographyMixin)('xxs', 'disabled'),
        url: (0, typographyMixin_1.typographyMixin)('xxs', 'url'),
        success: (0, typographyMixin_1.typographyMixin)('xxs', 'success'),
        warning: (0, typographyMixin_1.typographyMixin)('xxs', 'warning'),
        error: (0, typographyMixin_1.typographyMixin)('xxs', 'error'),
        contrastInvert: (0, typographyMixin_1.typographyMixin)('xxs', 'contrastInvert'),
        overlay: (0, typographyMixin_1.typographyMixin)('xxs', 'overlay'),
        overlayInvert: (0, typographyMixin_1.typographyMixin)('xxs', 'overlayInvert'),
    },
};
//# sourceMappingURL=predefinedMixins.js.map